<template>
  <header>
    <h1>#UnJourUneMesureMacron</h1>
    <p>
      La campagne est terminée mais la récupération politique c'est tous les
      jours&nbsp;! Pour cela, le gouvernement d’Emmanuel Macron a fait appel aux
      meilleurs cabinets de conseil pour trouver
      {{ this.total || "" }} mesures de tous bords et satisfaire tout le monde
      et personne à la fois.
    </p>
    <p>Voici le résultat.</p>
  </header>
  <main>
    <generator
      v-if="total"
      :choicesAttributes="choicesAttributes"
      :choicesProblems="choicesProblems"
      :choicesTypes="choicesTypes"
    />
    <p v-else>Chargement&hellip;</p>
  </main>
  <footer>
    <p>
      Générateur réalisé en partenariat avec McKingston, Accentware et
      <a
        href="https://twitter.com/enisseo"
        target="_blank"
        rel="noopener noreferrer"
        >@enisseo</a
      >. La cohérence et la pertinence politique ne sont pas garanties. Toute
      ressemblance avec de vraies mesures adoptées par le gouvernement ne serait
      pas si surprenante.
    </p>
  </footer>
</template>

<script>
import Generator from "./Generator.vue";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from "../firebase.js";
export default {
  name: "HomePage",
  components: {
    Generator,
  },
  data() {
    return {
      choices: [],
    };
  },
  computed: {
    total() {
      return (
        this.choicesTypes.length *
        this.choicesAttributes.length *
        this.choicesProblems.length
      );
    },
    choicesTypes() {
      return (this.choices || [])
        .filter(({ kind }) => kind === "type")
        .map(({ text }) => text);
    },
    choicesAttributes() {
      return (this.choices || [])
        .filter(({ kind }) => kind === "attribute")
        .map(({ text }) => text);
    },
    choicesProblems() {
      return (this.choices || [])
        .filter(({ kind }) => kind === "problem")
        .map(({ text }) => text);
    },
  },
  mounted() {
    this._queryUnsubscribe = onSnapshot(
      collection(firestore, "choices"),
      function (querySnapshot) {
        const choices = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (
            ["attribute", "problem", "type"].indexOf(data.kind) === -1 ||
            !data.text
          ) {
            console.log("Warning: " + JSON.stringify(data));
          }
          choices.push(data);
        });
        this.choices = choices;
      }.bind(this)
    );
  },
  beforeUnmount() {
    this._queryUnsubscribe();
  },
};
</script>

<style lang="scss">
header {
  h1 {
    color: #c3680b;
    font-size: 3.2em;
  }
  p {
    font-size: 1.6em;
    line-height: 120%;
  }
}
main {
  border-radius: 16px;
  background: white;
  margin: 15px -30px;
  padding: 30px;
  p {
    color: #999;
    font-size: 2.4em;
    padding: 15px 0;
  }
}
footer {
  p {
    color: #999;
    font-size: 1.2em;
    line-height: 100%;
  }
  a {
    color: #999;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
@media (max-width: 700px) {
  main {
    border-radius: 0;
  }
}
@media (max-width: 540px) {
  main {
    margin: 15px -15px;
    padding: 15px;
  }
}
</style>
